$(document).ready(function () {

  // Akkordion
  if (typeof Shopify === "undefined" || !Shopify.designMode) {
    $(".Accordion").find(".etx-accordion__content").hide();

    $(".etx-accordion-list[data-accordion-opened]").each(function () {
      $(this)
        .find(".etx-accordion")
        .first()
        .addClass("active")
        .find(".etx-accordion__content")
        .show();
    });

    $(".etx-accordion__header[data-accordion-clickable]").on(
      "click",
      function () {
        let accordion = $(this).closest(".etx-accordion");
        let accordionList = $(this).closest(".etx-accordion-list");

        if (accordion.hasClass("active")) {
          accordion.find(".etx-accordion__content").slideUp();
          accordion.removeClass("active");
        } else {
          if (typeof accordionList.data("accordion-multiple") === "undefined") {
            accordionList.find(".etx-accordion").removeClass("active");
            accordionList.find(".etx-accordion__content").slideUp();
          }

          accordion.find(".etx-accordion__content").slideDown();
          accordion.addClass("active");

          if (typeof accordionList.data("accordion-scrollup") !== "undefined") {
            /* Calculate offset AFTER slideup / slidedown animations are complete */
            setTimeout(() => {
              offset = accordion.offset().top - 120;

              if (offset != 0) {
                $("html, body").animate(
                  {
                    scrollTop: offset,
                  },
                  1000
                );
              }
            }, 750);
          }
        }
      }
    );
  } else {
    $(".Accordion").find(".etx-accordion__content").show();
  }
});
